import {
  USER_GET_CART_ITEMS_LOADING,
  USER_GET_CART_ITEMS_SUCCESS,
  USER_GET_CART_ITEMS_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { userGetCartItemsUrl } from "api/apiUrls";
import { notification } from "antd";
import cloneDeep from "lodash/cloneDeep";

export const userGetCartItemsActions =
  (userId: any, lang?: any, callback?: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: USER_GET_CART_ITEMS_LOADING, payload: true });
      const response = await listItemsService(
        `${userGetCartItemsUrl}${lang}/user/${userId}`,
        ""
      );

      if (response.status !== 200) {
        notification.error({
          message: "Something went wrong!",
          description: "Please refresh!",
        });
      } else {
        // Deep clone the payload
        const clonedData = cloneDeep(response.data);

        dispatch({
          type: USER_GET_CART_ITEMS_SUCCESS,
          payload: clonedData,
        });
      }
    } catch (err) {
      dispatch({ type: USER_GET_CART_ITEMS_FAILURE, payload: err });
    } finally {
      dispatch({ type: USER_GET_CART_ITEMS_LOADING, payload: false });
    }
  };
